import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccessInviteModel } from 'src/app/core/models/access-invite.model';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { Roles } from 'src/app/core/security/roles';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-invite-modal',
  templateUrl: './invite-modal.component.html',
  styleUrls: ['./invite-modal.component.scss']
})
export class InviteModalComponent {

  constructor(
    private modalRef: NgbActiveModal,
    private myFileApiService: MyfileApiService,
    private toasterNotificationService: ToasterNotificationService,
    private authService: AuthMyfileService,
  ) { }
  @Input() public model: any;
  @Input() public inviteType: LoginType = LoginType.Client;

  rolesList: string[] = [];
  selectedRolesArray: string[] = [];

  modalEdited: boolean = false;
  submitted: boolean = false;
  emailPattern = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  inviteData: AccessInviteModel = new AccessInviteModel();

  ngOnInit() {
    var userRoles = this.authService.currentUserContextValue?.authContext?.roles;

    if (userRoles?.indexOf(Roles.globalAdmin) !== -1) {
      this.rolesList = [Roles.admin, Roles.globalAdmin, Roles.csr, Roles.profile, Roles.sandbox, Roles.witness];
    } else if (userRoles?.indexOf(Roles.admin) !== -1) {
      this.rolesList = [Roles.admin, Roles.csr, Roles.profile, Roles.sandbox, Roles.witness];
    } else if (userRoles?.indexOf(Roles.csr) !== -1) {
      this.rolesList = [Roles.profile, Roles.sandbox, Roles.witness];
    } else if (userRoles?.indexOf(Roles.witness) !== -1) {
      this.rolesList = [Roles.profile, Roles.sandbox];
    } else {
      this.rolesList = [Roles.sandbox];
    }

  }

  sendEmail() {
    this.submitted = true;
    if (this.validation()) {
      this.modalEdited = false;
      this.inviteData.email = this.model.email.trim().toLowerCase();
      this.inviteData.businessUnitId = this.authService.currentUserContextValue?.businessUnitId;
      this.inviteData.loginType = this.inviteType
      this.inviteData.isProcessed = false;
      this.inviteData.name = this.model.firstName;
      if (this.inviteType == 0) {
        this.inviteData.roles = this.selectedRolesArray;
      }
      this.myFileApiService.createAccessInvite(this.inviteData)
        .subscribe((result) => {

          if (result) {
            this.toasterNotificationService.showSuccess($localize`:@@:Invite sent successfully.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
            this.modalRef.close();
          } else if (result == false) {
            this.toasterNotificationService.showWarning($localize`:@@:Invite not sent, please make sure email was valid.`, $localize`:@@Toast_Warn_Title_MissingInformation: Warning`);
          }
          this.submitted = false;
        });
    }
  }

  close() {
    if (this.modalEdited) {
      this.confirmExit();
    } else {
      this.modalRef.close();
    }
  }

  confirmExit() {
    Swal.fire({
      title: $localize`:@@SWAL_UnsavedChanges:You have unsaved changes!`,
      text: $localize`:@@:Are you sure you want to abandon this invite?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@SWAL_Yes_Discard:Yes, discard changes`,
      cancelButtonText: $localize`:@@:No, let me send it`
    }).then(result => {
      if (result && result.isConfirmed) {
        this.modalRef.close();
      }
    });
  }

  validation() {
    if (
      this.model.firstName != undefined
      && this.model.email != undefined
      && this.model.firstName != ""
      && this.model.email != ""
    ) {
      return true;
    }
    this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Warning`);
    return false;
  }

}
